import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import CustomerLogs from './CustomerLogs';
import { bindActionCreators, Dispatch } from 'redux';
import customerActions from '../../redux/modules/customer/customerActions';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    selectedCustomer: state.customer.selectedCustomer,
    isLoading: state.customer.isLoading,
    customerLogs: state.customer.customerLogs,
    dataButtons: state.settings.dataButtons,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getCustomerLogs: customerActions.getLoglines,
      setSelectedLogline: customerActions.setSelectedLogline,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerLogs);
